'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WixStylesNumberUtils = {
    getFullNumberStyles: function getFullNumberStyles(_ref) {
        var _ref$numberStyles = _ref.numberStyles,
            numberStyles = _ref$numberStyles === undefined ? {} : _ref$numberStyles;

        var ret = {};

        function set(id, _default) {
            if (_lodash2.default.isUndefined(numberStyles[id])) {
                ret[id] = _default;
            } else {
                ret[id] = numberStyles[id];
            }
        }

        set('wixmenu.menuview', 18);
        set('wixmenu.priceRange', 1);
        set('wixmenu.icontype', 2);
        set('wixmenu.colortype', 0);
        set('wixmenu.customicontype', 0);
        set('wixmenu.orderingmenuview', 100);
        set('wixorders.menulayout', 0);
        set('wixorders.priceRange', 0);
        set('wixorders.icontype', 2);
        set('wixorders.colortype', 0);
        set('wixorders.customicontype', 2);
        set('migration.ver2emptymenu', 0);
        set('WixStylesStore.version', 1);
        set("wixsocialbar.spacing", 20);
        set("wixsocialbar.manual.spacing", -1);
        set("wixsocialbar.alignment", 0);
        set("wixsocialbar.size", -1);
        set("wixsocialbar.mode", 0);
        set("wixsocialbar.theme", 100001000);
        set("wixsocialbar.theme.applied", 0);
        set("wixsocialbar.theme.custom", 165001001);
        set("wixsocialbar.index.facebook", 0);
        set("wixsocialbar.index.foursquare", 1);
        set("wixsocialbar.index.yelp", 2);
        set("wixsocialbar.index.tripadvisor", 3);
        set("wixsocialbar.index.twitter", 4);
        set("wixsocialbar.index.instagram", 5);

        // seating numbers
        set("wixseating.layout", 0);
        set("wixseating.alignment", 1);
        set("wixseating-bg-border-size", 1);
        set("wixseating-btn-border-size", 0);
        set("wixseating-btn-border-radius", 0);
        set("wixseating-field-border-size", 1);
        set("wixseating-bg-border-size-custom", 1);
        set("wixseating-btn-border-size-custom", 0);
        set("wixseating-btn-border-radius-custom", 0);
        set("wixseating-field-border-size-custom", 1);
        set("wixseating.selected.title", 0);
        set("wixseating.selected.button", 0);
        set("wixseating.selected.preset", 0);

        return ret;
    }
};

exports.default = WixStylesNumberUtils;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/WixStylesNumberUtils.js
// module id = 453
// module chunks = 0